export default "__VITE_ASSET__DIf2bNJ0__"